if (!customElements.get('quick-size-add')) {
  customElements.define(
    'quick-size-add',
    class QuickSizeAdd extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.sheet = this.querySelector('[data-qsa-sheet]');
        this.overlay = this.querySelector('[data-qsa-overlay]');
        this.addButton = this.querySelector('[data-qsa-add]');
        this.selectedVariantId = null;

        // Desktop: click a size on the card = add to cart immediately
        this.querySelectorAll('.quick-size__row--card [data-qsa-variant]').forEach((btn) => {
          btn.addEventListener('click', () => this.addToCart(btn.dataset.qsaVariant));
        });

        // Mobile sheet
        const opener = this.querySelector('[data-qsa-open]');
        if (opener) opener.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-qsa-close], [data-qsa-overlay]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        const sheetButtons = this.querySelectorAll('.quick-size__row--sheet [data-qsa-variant]');
        sheetButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            sheetButtons.forEach((b) => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
            this.selectedVariantId = btn.dataset.qsaVariant;
          });
        });
        // Preselect first available size
        const firstAvailable = this.querySelector('.quick-size__row--sheet [data-qsa-variant]:not([disabled])');
        if (firstAvailable) {
          firstAvailable.classList.add('is-selected');
          this.selectedVariantId = firstAvailable.dataset.qsaVariant;
        }

        if (this.addButton) {
          this.addButton.addEventListener('click', () => {
            if (this.selectedVariantId) this.addToCart(this.selectedVariantId, true);
          });
        }
      }

      open() {
        // Move the sheet/overlay to <body> so position:fixed is not trapped by
        // transformed ancestors (e.g. swiper carousel slides).
        if (!this.movedToBody && this.sheet && this.overlay) {
          document.body.appendChild(this.overlay);
          document.body.appendChild(this.sheet);
          this.movedToBody = true;
        }
        if (this.overlay) this.overlay.classList.add('is-open');
        if (this.sheet) this.sheet.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      close() {
        if (this.overlay) this.overlay.classList.remove('is-open');
        if (this.sheet) this.sheet.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      addToCart(variantId, fromSheet = false) {
        if (this.loading) return;
        this.loading = true;
        const spinner = this.addButton && this.addButton.querySelector('.loading-overlay__spinner');
        if (fromSheet && spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'quick-size-add',
                productVariantId: variantId,
                errors: response.description,
                message: response.message
              });
              return;
            }
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-size-add', productVariantId: variantId });
            if (fromSheet) this.close();
            this.cart.renderContents(response);
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.loading = false;
            if (fromSheet && spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
